import React from 'react';
import { useSelector } from 'react-redux';
import { selectIsSmallScreen } from 'store/pageStore';
import { LabelsContainer, SideFilter, TopCategoriesContainer } from './components';
import { useCatalogueContent, useCatalogueContentSlice } from './hooks';

import { ContentWrapper } from './styles';

export const CatalogueContent = () => {
	const isSmallScreen = useSelector(selectIsSmallScreen);

	/** инъектим редьюсер, в котором хранятся данные о текущем состоянии фильтра категорий и модалки фильтра */
	useCatalogueContentSlice();

	useCatalogueContent();

	return (
		<ContentWrapper>
			{!isSmallScreen && <SideFilter />}
			<div>
				{!isSmallScreen && <LabelsContainer />}
				<TopCategoriesContainer />
			</div>
		</ContentWrapper>
	);
};
